import clsx from "clsx";
import { FC } from "react";
import Highlighter from "react-highlight-words";

import { FramerTooltip } from "@ryde/controls";

import { checkWasChanged } from "./grid.helpers";

interface IRideHistoryLogGridCellProps {
  value: string;
  prevValue: string | null;
  isNeedToCheckPrev: boolean;
  search?: string;
}

export const RideHistoryLogGridCell: FC<IRideHistoryLogGridCellProps> = ({
  value,
  prevValue,
  isNeedToCheckPrev,
  search,
}) => {
  const wasChanged =
    prevValue !== null && isNeedToCheckPrev
      ? checkWasChanged(value, prevValue)
      : false;

  const isUnchanged = prevValue !== null && isNeedToCheckPrev && !wasChanged;

  const cellContent = search ? (
    <Highlighter
      searchWords={[search]}
      autoEscape={true}
      textToHighlight={value}
      highlightClassName="search-highlight"
    />
  ) : (
    value
  );

  return (
    <div
      className={clsx("ride-history-log__grid-cell", {
        "ride-history-log__grid-cell_was-changed": wasChanged,
        "ride-history-log__grid-cell_unchanged": isUnchanged,
      })}
    >
      <FramerTooltip content={value} rtlStrippedBottomLeftPlacement>
        {cellContent}
      </FramerTooltip>
    </div>
  );
};
